import { OrderStatusType } from '../transaction';

export enum OrderAction {
  Buy = 'BUY',
  Sell = 'SELL',
}

export enum OrderStatus {
  Ready = 'READY',
  Open = 'OPEN',
  Partial = 'PARTIAL',
  Rejected = 'REJECTED',
  Pending = 'PENDING',
  Active = 'ACTIVE',
  RequestAmend = 'REQUEST AMEND',
}

export interface OrderItem {
  action: OrderAction;
  amount_invested: number;
  amount_matched: number;
  amount_matched_fee: number;
  amount_matched_total: number;
  amount_open: number;
  amount_open_fee: number;
  amount_fee: number;
  amount_invested_fee: number;
  amount: number;
  currency: string;
  order_done: number;
  order_open: number;
  order_total: number;
  orderid: string;
  market_orderid: string;
  price: number;
  price_average: number;
  price_average_fee: number;
  price_average_portfolio: number;
  price_order: number;
  status: OrderStatusType;
  message: string;
  symbol: string;
  time: string;
  time_open: string;
  time_match: string;
  gtc: number;
  gtc_expired: string;
  gtc_status: string;
  amend_action: boolean;
  cancel_action: boolean;
  amount_matched_broker_fee: number;
  amount_matched_exchange_fee: number;
  label: string;
  trigger_price: number;
  config_type: string;
  smart_orderid: string;
  trailing_stop: SmartOrderTrailingStop;
}

export type OrderResponse = OrderItem[];

export interface BulkCancelByOrderId {
  ui_ref: string;
  order_id: string[];
  acc_no?: string;
  sales_name?: string;
}
